import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import api from '../../services/api';

const TYPE_STYLES = {
  info: 'border-l-blue-400 bg-blue-50',
  success: 'border-l-green-400 bg-green-50',
  warning: 'border-l-amber-400 bg-amber-50',
  error: 'border-l-red-400 bg-red-50',
};

const ParentNotificationsPage = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    api.get('/parent-portal/notifications')
      .then((res) => { if (res.data.success) setNotifications(res.data.data); })
      .catch(() => toast.error('Erreur de chargement'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const markAllRead = async () => {
    await api.put('/parent-portal/notifications/mark-all-read');
    load();
  };

  const markRead = async (id) => {
    await api.put(`/parent-portal/notifications/${id}/read`);
    setNotifications((prev) =>
      prev.map((n) => (n.id === id ? { ...n, is_read: 1 } : n))
    );
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-bold text-slate-900">Notifications</h2>
          <p className="text-sm text-slate-500">Alertes concernant vos enfants</p>
        </div>
        {notifications.some((n) => !n.is_read) && (
          <button onClick={markAllRead} className="text-sm text-primary-600 hover:underline">
            Tout marquer lu
          </button>
        )}
      </div>

      {loading ? (
        <div className="flex justify-center py-10">
          <div className="animate-spin w-6 h-6 border-2 border-primary-600 border-t-transparent rounded-full" />
        </div>
      ) : notifications.length === 0 ? (
        <div className="bg-white rounded-xl p-8 text-center text-slate-500">Aucune notification</div>
      ) : (
        <div className="space-y-2">
          {notifications.map((n) => (
            <div
              key={n.id}
              onClick={() => !n.is_read && markRead(n.id)}
              className={`border-l-4 rounded-r-xl p-4 cursor-pointer transition-opacity ${
                TYPE_STYLES[n.type] || TYPE_STYLES.info
              } ${n.is_read ? 'opacity-60' : ''}`}
            >
              <div className="flex items-start justify-between gap-2">
                <div>
                  <p className="font-medium text-slate-900">{n.title}</p>
                  <p className="text-sm text-slate-600 mt-1">{n.message}</p>
                  <p className="text-xs text-slate-400 mt-2">
                    {n.created_at ? new Date(n.created_at).toLocaleString('fr-FR') : ''}
                  </p>
                </div>
                {!n.is_read && (
                  <span className="w-2 h-2 rounded-full bg-primary-600 flex-shrink-0 mt-2" />
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ParentNotificationsPage;
